import { render, staticRenderFns } from "./algorithmConfig.vue?vue&type=template&id=0c777099&scoped=true"
import script from "./algorithmConfig.vue?vue&type=script&lang=js"
export * from "./algorithmConfig.vue?vue&type=script&lang=js"
import style0 from "./algorithmConfig.vue?vue&type=style&index=0&id=0c777099&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c777099",
  null
  
)

export default component.exports